// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading_3ygsK","scale":"style_scale_9roCZ","scaleItem":"style_scaleItem_22vBP","scaleItemMode":"style_scaleItemMode_gpI9K","precent":"style_precent_2EUYZ"};